<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Проверки</h5>
      <template v-if="inspections?.length">
        <ul class="info-list mt-2">
          <li class="d-flex flex-row border-bottom align-items-end pt-2">
            <span class="info-value">Всего проверок</span
            ><span class="info-bold text-end">{{ inspections.length }}</span>
          </li>
          <li
            v-for="item in topInspectionTypes"
            :key="item.label"
            class="d-flex flex-row border-bottom align-items-end pt-2"
          >
            <span class="info-value">{{ item.label }}</span
            ><span class="info-bold text-end">{{ item.count }}</span>
          </li>
          <li
            v-for="item in topInspectionStatuses"
            :key="item.label"
            class="d-flex flex-row border-bottom align-items-end pt-2"
          >
            <span class="info-value">{{ item.label }}</span
            ><span class="info-bold text-end">{{ item.count }}</span>
          </li>
        </ul>
      </template>
      <template v-else><p>Нет данных</p> </template>
      <button class="btn-primary btn-small d-block ms-auto mt-2" @click="emitChangeTab('tab-inspections')">
        Подробнее
      </button>
    </div>
  </div>
</template>

<script>
  import { defineComponent, computed } from 'vue';

  export default defineComponent({
    name: 'CheckingsInfo',
    props: {
      inspections: Array,
    },
    setup(props, { emit }) {
      const emitChangeTab = (newTab) => {
        emit('change-tab', newTab);
      };

      const buildTopCounts = (items, field) => {
        if (!items?.length) return [];

        const counts = items.reduce((acc, inspection) => {
          const rawValue = inspection?.[field];
          const label = typeof rawValue === 'string' ? rawValue.trim() : '';
          if (!label || label.toLowerCase() === 'null') {
            return acc;
          }
          acc[label] = (acc[label] || 0) + 1;
          return acc;
        }, {});

        return Object.entries(counts)
          .map(([label, count]) => ({ label, count }))
          .sort((a, b) => b.count - a.count)
          .slice(0, 4);
      };

      const topInspectionTypes = computed(() => buildTopCounts(props.inspections, 'verification_type'));
      const topInspectionStatuses = computed(() => buildTopCounts(props.inspections, 'status'));

      return {
        topInspectionTypes,
        topInspectionStatuses,
        emitChangeTab,
      };
    },
  });
</script>
